function getAllFields(form) {
  const { isFormValid, isFormDirty, ...rest } = form;
  return rest;
}

function getError(form, name) {
  return form[name] && form[name].error;
}

function getFieldValue(form, name) {
  return form[name] && form[name].value;
}

function isFormDirty(form) {
  return form.isFormDirty;
}

function isFormValid(form) {
  return form.isFormValid;
}

function isInValid(form, name) {
  return Boolean(form[name] && !form[name].valid);
}

function isDirty(form, name) {
  return Boolean(form[name] && form[name].dirty);
}

function isValid(form, name) {
  return Boolean(form[name] && form[name].valid);
}

export default {
  getAllFields,
  getError,
  getFieldValue,
  isFormDirty,
  isFormValid,
  isDirty,
  isInValid,
  isValid,
};



// WEBPACK FOOTER //
// ./src/features/Form/getters.js